
import { defineComponent, ref } from "vue";
import liveplay from "@/components/LivePlay.vue";
import LiveCount from "@/components/LiveCount.vue";
import VideoReview from "@/components/VideoReview.vue";
import infoad from "@/components/infoad.vue";

import { useRoute } from "vue-router";
import { getliveinfo, share } from "@/api";
import router from '@/router';
import { useI18n } from "@/utils/i18n";
export default defineComponent({
  components: {
    LiveCount,
    liveplay,
    VideoReview,
    infoad
  },
  setup() {
    console.log(useRoute().query.id);
    const id = useRoute().query.id;
    const liveinfo = ref<any>({})
    const visible = ref(false)
    const lan = useI18n()
    if (typeof id == "string") {
        getliveinfo(parseInt(id)).then((res) => {
            if(res.overdue == 1){
              visible.value = true;
            }
            liveinfo.value = res;
            console.log(res)
        });
    }
    return {
        liveinfo,
        visible,
        lan
    }
  },
});
